import { NgModule } from '@angular/core';
import { LetterInputDirective } from './letter-input.directive';
import { NumberInputDirective } from './number-input.directive';
import { NumericDirective } from './numeric.directive';

@NgModule({
  declarations: [
    LetterInputDirective,
    NumberInputDirective,
    NumericDirective,
  ],
  exports: [
    LetterInputDirective,
    NumberInputDirective,
    NumericDirective,
  ],
})
export class InvoiceDirectivesModule {

}
